//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    // required
    route: {
      type: String,
      required: true
    },
    // optional
    label: {
      type: String,
      required: false,
      default: ''
    }
  }
}
